module.exports = __webpack_public_path__ + "img/icon2.67f1b6b.png";